import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Modal from 'pages/Kyb/Modal';
import InputNumber from 'components/Fields/ReduxForm/InputNumber';
import { error as msgError } from 'actions/notifications';
import { actUploadNpwpFile, submitNpwpForm } from 'actions/setting/account';
import { npwpStart } from 'clevertap/settings/accounts';
import styles from './style.css';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'This field is required';
  } else if (values.name.trim().length < 1) {
    errors.name = 'This field is required';
  }
  if (!values.id) {
    errors.id = 'This field is required';
  } else if (values.id.trim().length < 1) {
    errors.id = 'This field is required';
  } else if (values.id.length !== 15) {
    errors.id = 'Enter a valid NPWP Number';
  }
  return errors;
};

const inputField = field => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className={`form-control ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

let NPWPUpload = class NPWPUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: null,
      file: null,
      img: null,
    };
    npwpStart();
    if (props.identity && props.identity.NPWP_IMAGE_URL) {
      this.initializeForm();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { npwpImage } = nextProps.data.kybForm;
    const { url, img } = this.state;
    this.setState({
      img: npwpImage,
      url: npwpImage !== img ? null : url,
    });
  }

  initializeForm() {
    const {
      NPWP_NAME: npwpName,
      NPWP_NUMBER: npwpNumber,
    } = this.props.identity;
    const initData = {
      name: npwpName,
      id: npwpNumber,
    };
    this.props.initialize(initData);
  }

  componentDidMount() {
    $('body').append($('#upload-photo'));
  }

  componentWillUnmount() {
    $('#upload-photo').remove();
  }

  handleUpload = e => {
    const file = e.target.files[0];
    const fileTypeAllowed = ['png', 'jpg', 'jpeg'];
    const fileSizeAllowed = Math.pow(10, 7); // 10 MB
    const fileType = file.type.split('/')[1];
    if (
      file &&
      file.size < fileSizeAllowed &&
      fileTypeAllowed.includes(fileType)
    ) {
      const reader = new FileReader();
      reader.onload = e => {
        this.setState(
          {
            url: reader.result,
            file,
          },
          () => {
            e.target.value = null;
            $('#upload-photo').modal({
              backdrop: 'static',
              keyboard: false,
              show: true,
            });
          }
        );
      };
      reader.readAsDataURL(file);
    } else if (file && file.size > fileSizeAllowed) {
      this.props.dispatch(msgError('Maximum file is 10 MB'));
      e.target.value = null;
    } else if (file && !fileTypeAllowed.includes(fileType)) {
      this.props.dispatch(
        msgError('File type is invalid please use ( jpg/jpeg/png )')
      );
      e.target.value = null;
    }
  };

  uploadFile = () => {
    const { id } = this.props.business;
    const data = {
      file: this.state.file,
      id,
    };
    this.props.dispatch(actUploadNpwpFile(data));
  };

  selectImage = () => {
    this.uploadFile();
  };

  handleNpwpUploadSubmit = values => {
    this.props.dispatch(
      submitNpwpForm({
        NPWP_NUMBER: values.id.trim(),
        NPWP_NAME: values.name.trim(),
        NPWP_IMAGE_URL: this.props.data.kybForm.npwpImage,
        businessId: this.props.business.id,
      })
    );
  };

  render() {
    const { handleSubmit, valid, data, onClickBack } = this.props;
    const { npwpImage } = data.kybForm;
    const { url } = this.state;
    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>
            ADD NOMOR POKOK WAJIB PAJAK (NPWP)
          </div>
        </div>
        <form
          className="col-xs-12"
          onSubmit={handleSubmit(this.handleNpwpUploadSubmit)}
        >
          <div>
            <div className={`${styles['business-form']}`}>
              <div className="form-group">
                <div className={`${styles['image-upload']}`}>
                  <label
                    htmlFor="file-input"
                    data-toggle="modal"
                    data-target={npwpImage !== null ? '#upload-photo' : ''}
                    data-backdrop="static"
                    data-keyboard="false"
                  >
                    <img
                      src={
                        npwpImage !== null
                          ? npwpImage
                          : 'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/upload-icon.png'
                      }
                    />
                  </label>
                  <div>
                    {!npwpImage && (
                      <input
                        type="file"
                        id="file-input"
                        name="file"
                        onChange={this.handleUpload}
                        accept="image/*"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className={styles['input-label']}>Name on NPWP</div>
                <Field
                  component={inputField}
                  name="name"
                  placeholder="Name on NPWP"
                  autoCorrect="off"
                  maxLength="30"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              </div>
              <div className="form-group">
                <div className={styles['input-label']}>NPWP Number</div>
                <Field
                  component={InputNumber}
                  customErrorClassName={styles['input-error']}
                  name="id"
                  placeholder="NPWP Number"
                  maxLength="15"
                />
              </div>
            </div>
          </div>
          <div className={`row ${styles['pb-50']}`}>
            <div className="col-12 col-xs-6">
              <button
                type="button"
                className={`btn btn-default ${styles['width-100']} ${
                  styles['back-button']
                }`}
                onClick={onClickBack}
              >
                Back
              </button>
            </div>
            <div className="col-12 col-xs-6">
              <button
                type="submit"
                disabled={!(npwpImage && valid)}
                className={`btn btn-primary ${styles['width-100']}`}
              >
                Save
              </button>
            </div>
          </div>
        </form>
        <Modal id="upload-photo" title={`Confirm photo of NPWP`}>
          <div className={`${styles['modal-content']}`}>
            <div className={`${styles['uploaded-img']}`}>
              <img src={url !== null ? url : npwpImage} alt="image" />
            </div>
            <div className={`${styles['upload-modal-btn']}`}>
              {url && (
                <button
                  className={`btn btn-block btn-primary`}
                  type="button"
                  onClick={this.selectImage}
                >
                  Use Photo
                </button>
              )}
              <input
                type="file"
                name="file"
                id="reupload"
                className={`${styles.reupload}`}
                onChange={this.handleUpload}
                accept="image/*"
              />
              <label
                className={`${styles['reupload-label']}`}
                htmlFor="reupload"
              >
                Reupload Photo
              </label>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
};

NPWPUpload = reduxForm({
  form: 'NPWPUpload',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(NPWPUpload);

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(NPWPUpload);
